/* src/app/support/service-popup/service-popup.component.css */
.service-popup-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.program-menu-bar,
.popup-row.top-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 12px;
  border-bottom: 1px solid #ddd;
  min-height: 40px;
}
.program-menu-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 12px;
  min-height: 40px;
}
.program-menu-bar .popup-title {
  font-size: 20px;
  font-weight: 500;
  margin-right: 32px;
  margin-bottom: 0;
  white-space: nowrap;
}
.popup-title {
  font-size: 20px;
  font-weight: 500;
  margin-right: 32px;
  margin-bottom: 0;
  white-space: nowrap;
}
.program-menu-bar button[mat-button] {
  min-width: 60px;
  font-size: 15px;
  font-weight: 400;
  text-transform: none;
}
.system-status-label {
  margin-left: auto;
  font-size: 15px;
  color: white;
  font-weight: 400;
}
.status-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-right: 32px;
}
.status-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}
.machines-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.machine-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}
.popup-row.bottom-row {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.popup-row.top-row,
.popup-row.middle-row {
  flex-shrink: 0;
}
.mat-tab-group,
.tab-content {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.tab-content {
  flex: 1 1 0;
  min-height: 0;
  overflow: auto;
  padding: 12px;
}
.mqtt-log-table {
  width: 100%;
  font-size: 13px;
  margin-bottom: 12px;
}
.empty-log {
  color: #888;
  text-align: center;
  margin-top: 16px;
}
.subtitle {
  font-weight: 600;
}
.online-icon {
  color: white;
  background-color: green;
}
.offline {
  color: white;
  background-color: red;
}
.busy {
  color: orange;
}
.unknown {
  background-color: gray;
}
.machines-row.cards-row {
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
  overflow-x: auto;
  width: 100%;
  align-items: stretch;
  height: 100%;
  min-height: 0;
  padding-left: 12px;
}
.machine-card {
  flex: 1 1 0;
  min-width: 250px;
  max-width: 250px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.machine-card mat-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 12px;
  margin-bottom: 12px;
}
mat-card-content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}
mat-card-footer.machine-status-bar {
  flex-shrink: 0;
}
.machine-card mat-card-content {
  padding-bottom: 16px;
}
.mat-card-avatar mat-icon {
  font-size: 72px !important;
  width: 72px !important;
  height: 72px !important;
  line-height: 72px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mat-card-avatar {
  width: 80px !important;
  height: 80px !important;
  min-width: 80px !important;
  min-height: 80px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
}
::ng-deep .machine-avatar .mat-icon {
  width: 40px !important;
  height: 40px !important;
}
::ng-deep .machine-avatar .material-icons {
  font-size: 40px !important;
}
.machine-menu-button {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}
.machine-status-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-top: 1px solid #eee;
  background: #fafafa;
  font-size: 16px;
  min-height: 40px;
}
.machine-status-bar .status-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.machine-status-bar .temperature-indicator {
  margin-left: auto;
  text-align: right;
  justify-content: flex-end;
  display: flex;
}
.machine-status-bar .temperature-indicator.cold {
  color: #1976d2;
}
.machine-status-bar .temperature-indicator.hot {
  color: #d32f2f;
}
.machine-status-bar .align-right {
  margin-left: auto;
}
.machine-status-bar .online {
  color: #388e3c !important;
}
.machine-status-bar .offline {
  color: #d32f2f !important;
}
.machine-status-bar .busy {
  color: #fbc02d !important;
}
.stale {
  color: #fafafa !important;
}
.status-bar-text {
  font-weight: 500;
  margin-left: 4px;
}
.stale-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(128, 128, 128, 0.35);
  z-index: 2;
  border-radius: 8px;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
.stale-text {
  color: #333;
  background: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  padding: 4px 10px;
  border-radius: 6px 6px 0 0;
  margin-bottom: 8px;
  font-weight: 500;
}
.card-spacer {
  flex: 1 1 auto;
  height: 20px;
}
.topbar-signal-btn {
}
.footer-row {
  padding-right: 12px;
  font-size: 13px;
  background-color: #333;
  color: #ccc;
  text-align: right;
}
.network-usable {
  color: #fbc02d !important;
}
.network-poor {
  color: #d32f2f !important;
  border-radius: 100%;
  animation: network-blink 1s steps(2, start) infinite;
}
@keyframes network-blink {
  to {
    visibility: hidden;
  }
}
.network-status-label {
  font-size: 16px;
}
.temperature-indicator {
  display: flex;
  align-items: right;
  width: 100%;
  gap: 4px;
}
.time-selector-dialog-content {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 0;
}
.time-selector-dialog-content .mat-form-field {
  width: 80px;
}
.time-selector-dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 12px;
}
/*# sourceMappingURL=service-popup.component.css.map */
